<template>
    <SboIcon
        v-if="sboIconName"
        v-bind:name="sboIconName"
        v-bind:size="size"
    />
    <SvgIcon
        v-else
        v-bind:name="name"
        v-bind:size="size"
        v-bind:color="color"
    />
</template>

<script lang="ts" setup>
    import type { IconName } from '@sbo/icons-vue';
    import type { PropType } from 'vue';
    import { computed } from 'vue';
    import SboIcon from '@/components/common/SboIcon.vue';
    import SvgIcon from '@/components/common/SvgIcon.vue';
    import { invertCapitalize } from '@/core/lib/string';
    import { SportType } from '@/interface/enum';

    const props = defineProps({
        sportType: {
            type: Number as PropType<SportType>,
            required: true,
        },
        colorful: {
            type: Boolean,
            required: false,
        },
        twoColor: {
            type: Boolean,
            required: false,
        },
        size: {
            type: [Number, String],
            default: () => 'default',
        },
        color: {
            type: String,
            default: () => '',
        },
    });

    const name = computed(() => {
        // eslint-disable-next-line no-nested-ternary
        const prefix = props.colorful
            ? 'icon-sport-color'
            : props.twoColor
                ? 'icon-sport-2color'
                : 'icon-sport';
        const sportName = invertCapitalize(SportType[props.sportType]);
        return `${prefix}-${sportName}`;
    });

    const isSboIconSports = [SportType.FantasySelection];

    const sboIconName = computed(() => {
        if (!props.sportType) return null;
        if (!isSboIconSports.includes(props.sportType)) return null;

        const sportName = invertCapitalize(SportType[props.sportType]);
        return `sports:${sportName}Outline` as IconName;
    });
</script>
